export class HierarchyC {
  chain: string;
  description: string;
  hoId: number;
  key: string;
  level: number;
  levelParent: string;
  levelUpdated: boolean;
  storeId: string;
  type: string;
  oldKey?: string;
}

